import { render, staticRenderFns } from "./TagSetup.vue?vue&type=template&id=17134c4f&scoped=true&"
import script from "./TagSetup.vue?vue&type=script&lang=ts&"
export * from "./TagSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17134c4f",
  null
  
)

export default component.exports